module.exports = __webpack_public_path__ + "img/chevron-right-1.fae4b20.png";